import { START_BUTTONS_STYLE } from "@client/content/controls/Form/lib";
import { IconType } from "@client/types";
import Button from "@common/controls/Button/component";
import { type WithChildren } from "@common/declarations";
import { useI18n } from "@common/hooks/i18n";
import React from "react";

type BackButtonProps = {
  onClick: () => void;
};

export const BackButton = (props: BackButtonProps) => {
  const i18n = useI18n();

  return (
    <Button icon={IconType.ArrowLeft} onClick={props.onClick} type="white">
      {i18n.back}
    </Button>
  );
};

type BackContainerProps = WithChildren & {
  onBackClick: () => void;
};
export const BackContainer = (props: BackContainerProps) => (
  <div>
    <div style={START_BUTTONS_STYLE}>
      <BackButton onClick={props.onBackClick} />
    </div>

    <div className="gap vertical" />

    <div className="content">{props.children}</div>
  </div>
);
